<template>
  <div class="listable">
    <div class="listable-head">
      <div class="th">Material No.</div>
      <div class="th">Type</div>
      <div class="th">Brand</div>
      <div class="th">Quantity</div>
    </div>
    <div v-for="(item, i) in materials" :key="i" class="listable-data">
      <div class="td">{{ item.number }}</div>
      <div class="td">{{ item.type_label }}</div>
      <div class="td">{{ brand(item) }}</div>
      <div class="td has-input">
        <Field
            type="text"
            :name="`materials[${item.id}]`"
            :value="item.num_ordered || 0"
            :disabled="!isEditable"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    materials: { type: Array, required: true },
    isEditable: { type: Boolean, required: true },
  },
  methods: {
    brand(item) {
      return !!item.brand ? item.brand.name : "Un-branded";
    }
  }
};
</script>
<style scoped>
    .has-input .element {
        width: 60px;
    }
</style>